import(/* webpackMode: "eager", webpackExports: ["OgScreenshotGenerator"] */ "/home/watchero/watchero-servers/packages/watchero.io/components/tools/open-graph-screenshot/og-screenshot-generator.tsx");
